//@ts-nocheck
import React, { Component } from "react";
import { observer } from "mobx-react";
import subscriptionState, {
  ISubsPlan,
} from "../../../shared/mobx/subscription-state";
import { formatNumberWithDecimal } from "../../../helpers/helpers";
import Spinner from "../../../components/bootstrap/Spinner";
import auth from "../../../shared/mobx/auth-state";
import ManagePackageModal from "./ManagePackageModal";

const currencyMapper = {
  USD: "$",
};

const sortOptionsByValue = (key, options) => {
  const qualityOrder = ["Low", "Medium", "High"];

  return Object.entries(options).sort(([, a], [, b]) => {
    if (key === "quality") {
      return (
        qualityOrder.indexOf(a.value) - qualityOrder.indexOf(b.value)
      );
    }

    if (key === "format") {
      const getDeviceType = (val) => {
        const lower = val.toLowerCase();
        if (lower.includes("desktop") || lower.includes("laptop")) return 0;
        if (lower.includes("ipad") || lower.includes("tablet")) return 1;
        if (lower.includes("iphone") || lower.includes("samsung galaxy")) return 2;
        return 3;
      };
      return getDeviceType(a.value) - getDeviceType(b.value);
    }

    return 0;
  });
};

class ManageSubscription extends Component {
  state = {
    activeTab: "month",
    isLoading: true,
    monthlyPackages: [],
    yearlyPackages: [],
    description: [],
    isModalOpen: false,
    selectedFeatures: {},
  };

  componentDidMount() {
    this.fetchSubscriptionDescriptions();
    window.addEventListener("resize", this.setEqualHeight);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setEqualHeight);
  }

  fetchSubscriptionDescriptions = async () => {
    try {
      this.setState({ isLoading: true });
      const packageList =
        await subscriptionState.getSubscriptiondescriptionPlans(false);
      this.setState({ description: packageList.access });

      const newData: ISubsPlan[] = packageList;

      const mappedMonthlyPackages = this.mapPackages(newData, "month");
      const mappedYearlyPackages = this.mapPackages(newData, "year");

      this.setState(
        {
          monthlyPackages: mappedMonthlyPackages,
          yearlyPackages: mappedYearlyPackages,
          isLoading: false,
        },
        this.setEqualHeight
      );
    } catch (error) {
      console.error("Error fetching subscription descriptions:", error);
    }
  };

  mapPackages = (data: ISubsPlan[], cycle: "month" | "year") => {
    if (!Array.isArray(data)) {
      return [];
    }

    return data
      .filter((plan) => plan.billing_cycle?.interval === cycle)
      .map((plan) => ({
        id: plan.id,
        planId: plan.plan_id,
        name: plan.name,
        features: [plan.description],
        price: `${currencyMapper[plan.unit_price?.currency_code] ?? plan.unit_price?.currency_code}${formatNumberWithDecimal(plan.unit_price?.amount)}/${plan.billing_cycle?.interval}`,
        icon: plan.icon,
      }));
  };

  setEqualHeight = () => {
    const packageCards = document.querySelectorAll(".packege-detail");
    let maxHeight = 0;

    packageCards.forEach((card) => {
      card.style.height = "auto";
      maxHeight = Math.max(maxHeight, card.clientHeight);
    });

    packageCards.forEach((card) => {
      card.style.height = `${maxHeight}px`;
    });
  };

  handleManagePackages = (features, plan_id) => {
    this.setState({
      selectedFeatures: { ...features },
      planId: plan_id,
      isModalOpen: true,
    });
  };

  handleModalSave = (updatedFeatures) => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const { activeTab, isLoading, description, isModalOpen, selectedFeatures } = this.state;

    return (
      <div className="container" id="pricing">
        <div className="packages-section">
          <div className="tabs">
            <button
              className={`tab ${activeTab === "month" ? "active" : ""}`}
              onClick={() =>
                this.setState({ activeTab: "month" }, this.setEqualHeight)
              }
            >
              Monthly
            </button>
            <button
              className={`tab ${activeTab === "year" ? "active" : ""}`}
              onClick={() =>
                this.setState({ activeTab: "year" }, this.setEqualHeight)
              }
            >
              Yearly
            </button>
          </div>

          <div className="packages">
            {isLoading ? (
              <Spinner size="4rem" color="danger" />
            ) : (
              <div className="row">
                {Array.isArray(description) && description.length > 0 ? (
                  description
                    .filter((plan) => plan.interval === activeTab)
                    .map((plan, index) => {
                      const accessData = plan.access;
                      return (
                        <div key={index} className="col-12 col-md-6 col-lg-3">
                          <div className="package card-stretch-full">
                            <div className="packege-header">
                              <div className="packege-price">
                                <h3 className="text-xl font-bold">
                                  {plan.title}
                                </h3>
                                <p className="price">
                                  {plan.unit_price
                                    ? `${currencyMapper[plan.unit_price.currency_code] ?? plan.unit_price.currency_code} ${formatNumberWithDecimal(plan.unit_price.amount)} / ${plan.interval}`
                                    : "No price available"}
                                </p>
                              </div>
                              <img
                                src={`/images/plan/${plan.icon}`}
                                alt={plan.title}
                                className="package-icon"
                              />
                            </div>
                            <div className="packege-detail">
                              <div
                                className="text-sm mb-2"
                                dangerouslySetInnerHTML={{
                                  __html: plan.description || "",
                                }}
                              />
                              <span className="text-uppercase">FEATURES</span>
                              <ul className="list-disc list-inside">
                                {Object.entries(accessData).map(([key, value]) => {
                                  if (value && typeof value === "object" && value.label && value.options) {
                                    return (
                                      <li key={key}>
                                        <strong className="p-0">
                                          {value.tooltip ? (
                                            <tooltip className="custom-tooltip">
                                              {value.label}
                                              <span className="custom-tooltip-text">
                                                {value.tooltip_text}
                                              </span>
                                            </tooltip>
                                          ) : (
                                            value.label
                                          )}
                                        </strong>
                                        <ul>
                                          {key === "Additional_features" ? '' : (
                                            sortOptionsByValue(key, value.options).map(([subKey, subValue]) => (
                                              <ul className="ps-3" key={subKey}>
                                                <li>
                                                  {subValue.tooltip ? (
                                                    <tooltip className="custom-tooltip">
                                                      {subValue.label && `${subValue.label} : `}
                                                      {subValue.value}
                                                      <span className="custom-tooltip-text">
                                                        {subValue.tooltip_text}
                                                      </span>
                                                    </tooltip>
                                                  ) : (
                                                    <>
                                                      {subValue.label && `${subValue.label} : `}
                                                      {subValue.value}
                                                    </>
                                                  )}
                                                </li>
                                              </ul>
                                            ))
                                          )}
                                        </ul>
                                      </li>
                                    );
                                  } else if (
                                    typeof value === "string" ||
                                    typeof value === "number"
                                  ) {
                                    return (
                                      <li key={key}>
                                        <strong>
                                          {key.charAt(0).toUpperCase() + key.slice(1)}:
                                        </strong>{" "}
                                        {value}
                                      </li>
                                    );
                                  }
                                  return null;
                                })}
                              </ul>
                            </div>
                            <div className="packege-btn">
                              {auth.isAdmin && (
                                <button
                                  className="subscribe-btn"
                                  onClick={() =>
                                    this.handleManagePackages(
                                      accessData,
                                      plan.plan_id
                                    )
                                  }
                                >
                                  Manage Packages
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div>No descriptions available.</div>
                )}
              </div>
            )}
          </div>
        </div>

        {isModalOpen && (
          <ManagePackageModal
            isOpen={isModalOpen}
            onClose={() => this.setState({ isModalOpen: false })}
            features={selectedFeatures}
            planId={this.state.planId}
            onSave={this.handleModalSave}
          />
        )}
      </div>
    );
  }
}

export default observer(ManageSubscription);
